export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.790f10e0.worker.js");
}
